<template>
    <div>
        <ui-select
            v-model="internalValue"
            :options="availableVatTariffs"
            :label="label"
            :disabled="disabled"
            @change="$emit('change', internalValue ? internalValue.value : null)"
            @input="$emit('input', internalValue ? internalValue.value : null)"
        />
    </div>
</template>

<script>
    import { VatTariffList } from '../../../classes/VatService'

    export default {
        props: {
            value: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default: 'VAT Tariff'
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                internalValue: null,
                VatTariffList
            }
        },
        watch: {
            value(n, o) {
                if (n !== o) {
                    this.setInternalValue(n)
                }
            }
        },
        created() {
            this.setInternalValue(this.value)
        },
        methods: {
            setInternalValue(value) {
                this.internalValue = VatTariffList.find(i => i.value === value)
            }
        },
        computed: {
            availableVatTariffs() {
                return VatTariffList.filter(option => {
                    return window.marque.ui.availableVatTariffs.includes(option.value)
                })
            }
        }
    }
</script>